import React from 'react';

const Pagination = ({ pager, handlePaginaTion, currentPage }) => {
  if (pager.length <= 1) {
    return <></>
  }
  const currentPageIndex = (currentPage - 1)

  return (
    <ul className="pagination">
      <li>
        <button
          className={currentPageIndex - 1 === -1 ? 'page-arrow page-arrow--first disabled' : 'page-arrow page-arrow--first'}
          onClick={() => { handlePaginaTion(1) }}
        />
      </li>
      <li>
        <button
          onClick={() => { handlePaginaTion(currentPage - 1) }}
          className={currentPageIndex - 1 === -1 ? 'page-arrow page-arrow--previous disabled' : 'page-arrow page-arrow--previous'}
        />
      </li>
      {pager.map((page, index) => (
        <li key={index}>
          <button
            id={page.id}
            className={currentPage === (index + 1) ? 'page-item active' : 'page-item'}
            onClick={() => { handlePaginaTion(index + 1) }}>
            {index + 1}
          </button>
        </li>
      ))}
      <li>
        <button
          className={currentPage >= pager.length ? 'page-arrow page-arrow--next disabled' : 'page-arrow page-arrow--next'}
          onClick={() => { handlePaginaTion(currentPage + 1) }} />
      </li>
      <li>
        <button
          className={currentPage >= pager.length ? 'page-arrow page-arrow--last disabled' : 'page-arrow page-arrow--last'}
          onClick={() => { handlePaginaTion(pager.length) }}
        />
      </li>
    </ul>
  )
}

export default Pagination;
